import Component from '../../../assets/scripts/modules/component';
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event';


class InviteAFriend extends Component {
  init() {

    window.addEventListener('invite-a-friend:start', () => {

        // if native share function is available
        if (navigator.share) {
          this.share('native');
        }
        else {

          // open lightbox
          fireCustomEvent('lightbox:show', { id: 'invite-a-friend' });

          // show content
          this.show();
        }
    });

    // handle share clicks
    this.element.querySelectorAll('[data-role=share]').forEach( (button) => {
      button.addEventListener('click', this.onShare.bind(this));
    });
  }

  onShare(event) {
    event.preventDefault();

    const type = event.currentTarget.dataset.type;
    this.share(type);
  }

  share(type) {

    // // grab from OG data (don't make it static, sometimes data can be changed)
    // const title = document.querySelector('meta[property="og:image"]').content;
    // const description = document.querySelector('meta[property="og:description"]').content;
    // let url = document.querySelector('meta[property="og:url"]').content;
    // const image = document.querySelector('meta[property="og:image"]').content;
    //
    // url = "https://fabrique.nl";

    if (type === 'native' && navigator.share) {
      navigator.share({
        title: document.title,
        text: 'MUAC event',
        url: 'http://muac.unam.mx',
      });
    }
  }

  show() {
    this.element.classList.add('is-visible');
  }

  hide() {
    this.element.classList.remove('is-visible');
  }
}

for (const element of document.querySelectorAll('.invite-a-friend')) {
  element.instance = new InviteAFriend('invite-a-friend', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/structures/invite-a-friend/invite-a-friend.js